/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Böck <f.hartl@techdivision.com>
 */
import dayjs from 'dayjs';

/**
 * Checkout Settings
 */
export const checkoutSettings = {
  minimalDateOfBirthToCheckout: dayjs()
    .subtract(15, 'year')
    .toString(),
};
